/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import usageTracker from '../../lib/usageTracker';
import ChecklistPage from './ChecklistPage';
import TrialCtaPage from './TrialCtaPage';
import LoadingPage from './LoadingPage';
import MobilePage from './MobilePage';
import OverallPage from './OverallPage';
import PerformancePage from './PerformancePage';
import SecurityPage from './SecurityPage';
import SeoPage from './SeoPage';
import ShareBanner from '../ShareBanner';
import OverallGrade from '../sidepanel/OverallGrade';
import GraderActionCreator from '../../actions/GraderActionCreator';
import PreviewActionCreator from '../../actions/PreviewActionCreator';
import MainToolBar from '../header/MainToolBar';
import { getWebsiteGrade } from '../../selectors/Grader';
import TwoColumnLayout from '../layouts/TwoColumnLayout';
import Footer from '../footer/Footer';
import { useTheme } from 'styled-components';
import TrialCta from '../sidepanel/TrialCta';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (() => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const websiteGrade = useSelector(getWebsiteGrade);
  const {
    websiteUrl
  } = useParams();
  const loadWebsiteGrade = () => {
    dispatch(GraderActionCreator.getGrade(websiteUrl));
    dispatch(PreviewActionCreator.previewWebsite(websiteUrl));
  };
  useEffect(() => {
    usageTracker.logView('Results', {
      theme: theme.name
    });
    loadWebsiteGrade();
    return () => dispatch(GraderActionCreator.resultsPageUnmounted());
  }, []);
  const renderLoading = () => {
    return /*#__PURE__*/_jsx(LoadingPage, {
      websiteUrl: websiteUrl
    });
  };
  const renderResults = () => {
    return /*#__PURE__*/_jsx(TwoColumnLayout, {
      "data-test-id": "results-page",
      footer: /*#__PURE__*/_jsx(Footer, {}),
      leftContent: /*#__PURE__*/_jsx(OverallGrade, {
        websiteGrade: websiteGrade,
        ctaSection: /*#__PURE__*/_jsx(TrialCta, {
          websiteUrl: websiteUrl
        })
      }),
      rightContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MainToolBar, {}), /*#__PURE__*/_jsx(OverallPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(PerformancePage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(SeoPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(MobilePage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(SecurityPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(ChecklistPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(ShareBanner, {
          websiteUrl: websiteUrl
        }), /*#__PURE__*/_jsx(TrialCtaPage, {
          websiteUrl: websiteUrl
        })]
      })
    });
  };
  if (websiteGrade.loading) {
    return renderLoading(websiteGrade);
  } else {
    return renderResults(websiteGrade);
  }
});